import { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'

import {
  EuiPage,
  EuiPageBody,
  EuiPageContent,
  EuiPageContentBody,
  EuiPageContentHeader,
  EuiPageContentHeaderSection,
  EuiFieldPassword,
  EuiButton,
  EuiFieldText,
  EuiForm,
  EuiFormRow,
  EuiSpacer,
  EuiIcon,
} from '@elastic/eui'

import AuthService from '../services/auth.service'

const required = (value) => {
  if (!value) {
    return (
      <div className="alert alert-danger" role="alert">
        This field is required!
      </div>
    )
  }
}

const Login = () => {
  const navigate = useNavigate()

  //input Password

  const [username, setUsername] = useState('')
  const [password, setPassword] = useState('')
  const [message, setMessage] = useState('')

  const onChangeUsername = (e) => {
    const username = e.target.value
    setUsername(username)
  }

  const onChangePassword = (e) => {
    const password = e.target.value
    setPassword(password)
  }

  const handleLogin = (e) => {
    e.preventDefault()

    setMessage('')


    AuthService.login(username, password).then(
      () => {
        window.location.href = '/Dashboard'
      },
      (error) => {
        let resMessage =
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          error.message ||
          error.toString()

        const status = error.response?.status
        if (status === undefined) {
          // Network error / CORS / serveur injoignable
          resMessage = "Impossible de joindre le serveur."
        } else if (status === 429) {
          resMessage = "Trop de tentatives, réessayez dans quelques minutes."
        } else if (status > 400 && status < 500) {
          resMessage = "Login/mot de passe erroné ou vous n'êtes pas autorisé"
        } else if (status >= 500) {
          resMessage = "Erreur interne du serveur."
        }
        setMessage(resMessage)
      },
    )
  }

    const getUser = () => {
     const user = AuthService.getCurrentUser()
     if (user) {
       return navigate('/Dashboard')
     }
   }

   useEffect(() => {
     getUser()
   }, []);

  return (
    <EuiPage>
      <EuiPageBody id="loginPage" component="div">
        <EuiPageContent verticalPosition="center" horizontalPosition="center">
          <EuiPageContentHeader>
            <EuiPageContentHeaderSection>
              <EuiIcon type="/static/cybervision/img/logo-cybervision-cartouche.svg" />
            </EuiPageContentHeaderSection>
          </EuiPageContentHeader>
          <EuiPageContentBody>
            <EuiForm component="form" onSubmit={handleLogin}>
              <EuiFormRow fullWidth label="Login ESTOC">
                <EuiFieldText
                  name="username"
                  value={username}
                  validations={[required]}
                  onChange={(e) => onChangeUsername(e)}
                />
              </EuiFormRow>
              <EuiSpacer />

              <EuiFormRow fullWidth label="Mot de passe">
                <EuiFieldPassword
                  name="password"
                  type="dual"
                  value={password}
                  validations={[required]}
                  onChange={(e) => onChangePassword(e)}
                />
              </EuiFormRow>
              <EuiSpacer />

              <EuiButton type="submit" fullWidth fill>
                Connexion
              </EuiButton>
            </EuiForm>

            <EuiSpacer />
            <span>Utilisez le login Estoc (Exemple : a.dupont).</span>
            {message && (
              <div className="form-group">
                <div className="alert alert-danger" role="alert">
                  {message}
                </div>
              </div>
            )}
          </EuiPageContentBody>
        </EuiPageContent>
      </EuiPageBody>
    </EuiPage>
  )
}

export default Login
